import script from "./financeSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./financeSupplier.vue?vue&type=script&setup=true&lang=js"

import "./financeSupplier.vue?vue&type=style&index=0&id=6556e0b5&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6556e0b5"]])

export default __exports__